import React, { Component } from "react";
import Video from "twilio-video";
import axios from "axios";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import Spinner from "../common/Spinner";
// const $leave = $('#leave-room');
// const $room = $('#room');
// const $activeParticipant = $('div#active-participant > div.participant.main', $room);
// const $activeVideo = $('video', $activeParticipant);
// const $participants = $('div#participants', $room);
import {
  Button,
  Row,
  Card,
  CardText,
  Col,
  Container,
  Input,
  Table
} from "reactstrap";
import { prescriptionDeleted } from "../../actions/mqttAction";
import { startVideoCall } from "../../actions/mqttAction";
import decode from "jwt-decode";
import { Button as Button1, Grid, Header, Segment, Portal } from 'semantic-ui-react'

class VideoComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeParticipant: null,
      identity: null,
      roomName: "",
      roomNameErr: false, // Track error for room name Input
      previewTracks: null,
      localMediaAvailable: false,
      hasJoinedRoom: false,
      activeRoom: null,
      remoteStatus: "",
      role: "", // Track the current active room
      openClosePortal: false,
      localStream: null,
    };
    this.joinRoom = this.joinRoom.bind(this);

    this.startCall = this.startCall.bind(this);
    this.handleRoomNameChange = this.handleRoomNameChange.bind(this);
    // this.roomJoined = this.roomJoined.bind(this);
    if (!this.props.isManualDial) {
      this.dispensePrescription = this.dispensePrescription.bind(this);
    }
    this.dispensePrescription = this.dispensePrescription.bind(this);
    this.leaveRoom = this.leaveRoom.bind(this);
    // this.detachTrack = this.detachTrack.bind(this);
    // this.attachTrack = this.attachTrack.bind(this);

    this.handlePortalClose = this.handlePortalClose.bind(this);
    this.handlePortalOpen = this.handlePortalOpen.bind(this);
  }

  handlePortalClose = () => { this.setState({ ...this.state, openClosePortal: false }); this.state.role === "TECHNICIAN" ? window.location = "/store" : window.location = "/"; }
  handlePortalOpen = () => this.setState({ ...this.state, openClosePortal: true })

  handleRoomNameChange(e) {
    let roomName = e.target.value;
    this.setState({ roomName: roomName });
  }

  UNSAFE_componentWillMount() {
    axios.get("https://prod-api.telerx.io:8443/token").then(results => {
      const { identity, token } = results.data;
      let orgId, role, branches;
      if (localStorage.jwtToken) {
        let decoded = decode(localStorage.jwtToken);
        orgId = decoded.orgId;
        role = decoded.roles[0];
        //branches = decoded.branch;
      } else {
        orgId = 1;
        role = "TECHNICIAN";
        //branches = "Chama";
      }

      if (this.props.isManualDial) {
        this.state.roomName = this.props.mqtt.show_store_view.destinationName
      }
      else {
        this.state.roomName = this.props.roomName
      }
      this.setState({ ...this.state, identity, token, role: role });
      if (role === "PHARMACIST") {
        this.joinRoom();
      }
      else if (role === "TECHNICIAN" && this.props.initiateCall) {
        this.joinRoom();
      }

    });
  }
  UNSAFE_componentWillReceiveProps(nextProps) {

    if (!this.state.hasJoinedRoom && Object.keys(nextProps.mqtt.start_counsel_call).length > 0) {
      this.setState({
        ...this.state,
        roomName: this.props.roomName
      })

      console.log('this.props.roomName :>> ', this.props.roomName);
      this.joinRoom();
    }

  }

  componentWillUnmount() {
    this.leaveRoom()
  }


  startCall() {

    let orgId, role, branches;
    if (localStorage.jwtToken) {
      let decoded = decode(localStorage.jwtToken);
      orgId = decoded.orgId;
      role = decoded.roles[0];
      //branches = decoded.branch;
    } else {
      orgId = 1;
      role = "TECHNICIAN";
      //branches = "Chama";
    }
    this.setState({
      ...this.state,
      role: role
    })
    //console.log("===============Initial ROle============"+role)
    if (role === "TECHNICIAN") {
      //this.props.startVideoCall(this.props.mqtt.getPrescriptionByStatus);
      this.setState({
        ...this.state,
        remoteStatus: "to_connect"
      })
    }
    // else{
    //   this.setState({
    //     ...this.state,
    //     role:"PHARMACIST"
    //   })
    // }
    const video = document.getElementById("video");
    // preview screen
    navigator.mediaDevices.getUserMedia({ video: true, audio: true })
      .then(vid => {
        video.srcObject = vid;
        this.state.localStream = vid;
      })
    this.joinRoom()
  }

  dispensePrescription() {
    this.props.dispensePrescription();
    this.setState({
      hasJoinedRoom: false,
      localMediaAvailable: false,
      roomName: ""
    });
    this.state.activeRoom.disconnect();
  }

  leaveRoom() {
    //this.props.dispensePrescription();
    //console.log("+===========Leave ROom===========")
    this.setState({
      hasJoinedRoom: false,
      localMediaAvailable: false,
      roomName: "",
      remoteStatus: ""
    });

    this.state.activeRoom.disconnect();
    this.handlePortalOpen()

  }

  // 2.x twilio-video - Start
  // connect participant
  participantConnected = (participant) => {
    console.log(`Participant ${participant.identity} connected'`);
    this.setState({
      localMediaAvailable: true,
      hasJoinedRoom: true,
      remoteStatus: "connected"
    });

    const div = document.getElementById('remote-media'); //create div for new participant
    // div.id = participant.sid;

    participant.on('trackSubscribed', track => this.trackSubscribed(div, track));
    participant.on('trackUnsubscribed', this.trackUnsubscribed);

    participant.tracks.forEach(publication => {
      if (publication.isSubscribed) {
        this.trackSubscribed(div, publication.track);
      }
    });
    // document.body.appendChild(div);
  }

  participantDisconnected = (participant) => {
    console.log(`Participant ${participant.identity} disconnected.`);
    // document.getElementById(participant.sid).remove();
    this.leaveRoom()
  }

  trackSubscribed = (div, track) => {
    div.appendChild(track.attach());
  }

  trackUnsubscribed = (track) => {
    track.detach().forEach(element => element.remove());
  }

  /**
   * Join a Room.
   * @param token - the AccessToken used to join a Room
   * @param connectOptions - the ConnectOptions used to join a Room
   */
  joinRoom = () => {

    if (!this.state.roomName.trim()) {
      this.setState({ roomNameErr: true });
      return;
    }
    console.log("Joining room '" + this.state.roomName + "'...");

    let connectOptions = {
      name: this.state.roomName
    };
    // Comment the next two lines to disable verbose logging.
    const logger = Video.Logger.getLogger('twilio-video');
    logger.setLevel('info');

    // Join to the Room with the given AccessToken and ConnectOptions.
    Video.connect(this.state.token, connectOptions).then(room => {

      //////////////////////////////
      let orgId, role, branches;
      if (localStorage.jwtToken) {
        let decoded = decode(localStorage.jwtToken);
        orgId = decoded.orgId;
        role = decoded.roles[0];
        //branches = decoded.branch;
      } else {
        orgId = 1;
        role = "TECHNICIAN";
        //branches = "Chama";
      }
      this.setState({
        ...this.state,
        role: role
      })
      //console.log("===============Initial ROle============"+role)
      if (role === "TECHNICIAN") {
        this.props.startVideoCall(this.props.mqtt.getPrescriptionByStatus);
        // this.setState({
        //   ...this.state,
        //   remoteStatus:"to_connect"
        // })
      }


      console.log(`Connected to Room ${room.name}`);
      this.state.activeRoom = room;

      room.participants.forEach(this.participantConnected);
      room.on("participantConnected", this.participantConnected);

      room.on("participantDisconnected", this.participantDisconnected);
      room.once("disconnected", (error) => {
        console.log('error :>> ', error);
        room.participants.forEach(this.participantDisconnected)
      }
      );
    }).catch(err => {
      console.log('err :>> ', err);
    })

  }

  // 2.x twilio-video - End
  render() {
    // Only show video track after user has joined a room
    let { remoteStatus, role } = this.state
    let remote_media, dispense_button = <div></div>;
    let joinOrLeaveRoomButton;
    console.log("=============role==========" + this.state.role, ':::::', remoteStatus)
    if (role === "TECHNICIAN") {
      if (remoteStatus === "in_connect") {
        remote_media = <div></div>
        // <h3 className="text-center">Welcome! Click Call My Pharmacist to Connect</h3>
      }
      else if (remoteStatus === "connected") {
        remote_media = <div className="flex-item remote-video" ref="remoteMedia" id="remote-media" />
      }
      console.log('this.state.hasJoinedRoom :>> ', this.state.hasJoinedRoom);
      joinOrLeaveRoomButton = this.state.hasJoinedRoom ? (

        role !== "TECHNICIAN" && <Button label="Disconnect" color="danger" onClick={this.dispensePrescription} style={{ float: "center" }}>
          End counselling
        </Button>
      ) : (
        <Button
          size="lg" block
          label="Connect"
          color="success"
          className="pull-right py-4"
          onClick={this.startCall}
        // style={{ float: "center", fontWeight: "bold" }}
        >
          Call My Pharmacist
        </Button>


      );
      if (this.props.initiateCall && !this.state.hasJoinedRoom) {
        joinOrLeaveRoomButton = <Button1 loading>Loading</Button1>
      }
    } else {
      // if(remoteStatus === "to_connect"){
      //   remote_media = <div className="text-center"><Spinner></Spinner>
      //   <h3>Contacting a PHARMACIST. please wait...</h3>
      // </div>
      // }
      //console.log("=============remote status=============="+remoteStatus)
      if (remoteStatus === "connected") {
        remote_media = <div className="flex-item remote-video" ref="remoteMedia" id="remote-media" />

      }
      else {
        remote_media = <div className="text-center"><Spinner></Spinner>
          <h3>we are connecting to patient... please wait...</h3>
        </div>
      }
      //remote_media = <div className="flex-item remote-video" ref="remoteMedia" id="remote-media" />
      //   dispense_button = <Button label="Dispense" color="info" onClick={this.dispensePrescription} >
      //   Dispense
      // </Button>
      joinOrLeaveRoomButton = this.state.hasJoinedRoom ? (
        <Button label="Disconnect" color="danger" onClick={!this.props.isManualDial ? this.dispensePrescription : this.handlePortalClose} style={{ float: "center" }}>
          End Counselling
        </Button>
      ) : (
        <Button
          label="Connect"
          color="danger"
          className="pull-right"
          onClick={this.startCall}
          style={{ float: "center" }}
        >
          Proceed to counselling
        </Button>
      );


    }

    let showLocalTrack = this.state.localMediaAvailable ? (
      <div className="flex-item local-video" id="local-media" ref="localMedia" />
    ) : (
      ""
    );
    let buttons = <Row>
      <Col>

      </Col>
      <Col>
        {joinOrLeaveRoomButton}
      </Col>
      <Col>
        {dispense_button}
      </Col>
    </Row>

    return (
      <Card>
        <CardText>
          <div className="flex-container video-cont">
            {/* <div className="flex-item remote-video" ref="remoteMedia" id="remote-media" /> */}
            {remote_media}
            <div className="flex-item local-video stack-top" id="video" ref="localMedia" />
            {/* <div className="flex-item remote-video" ref="remoteMedia" id="remote-media" /> */}
            {/* <hr></hr> */}
            {/* <div className="flex-item">
              <br />

            </div> */}
            {/* {showLocalTrack} */}
          </div>
          {buttons}
          {/* <hr style={{ marginBottom: "20px" }}></hr> */}
          {/* <div>
            {buttons}
          </div> */}

        </CardText>
        <Portal onClose={this.handlePortalClose} open={this.state.openClosePortal}>
          <Segment
            style={{
              left: '40%',
              position: 'fixed',
              top: '50%',
              zIndex: 1000,
            }}
          >
            <Header>Call Disconnected...</Header>
            {/* <p>To close, simply click the close button or click away</p> */}

            <Button1
              style={{ float: "right" }}
              content='Close Portal'
              positive
              onClick={this.handlePortalClose}
            />
          </Segment>
        </Portal>
      </Card>
    );
  }
}

VideoComponent.propTypes = {
  prescriptionDeleted: PropTypes.func.isRequired,
  startVideoCall: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  mqtt: state.mqtt
});

export default connect(mapStateToProps, { prescriptionDeleted, startVideoCall })(
  VideoComponent
);
